import { ReactNode } from "react";

export const Popover = ({ children, target }: { children: ReactNode; target: ReactNode }) => {
  return (
    <span className="relative flex flex-grow flex-row">
      {/* Focusable so tapping opens it on touch screens, which have no hover. */}
      <span className="peer cursor-help" tabIndex={0}>
        {target}
      </span>
      <div className="hidden peer-hover:flex peer-focus:flex text-sm absolute top-full bg-gray-800 bg-opacity-90 text-white z-50 rounded p-2 mt-1">
        {children}
      </div>
    </span>
  );
};
